import { render, staticRenderFns } from "./RefreshApp.vue?vue&type=template&id=5e59b4e4&"
import script from "./RefreshApp.vue?vue&type=script&lang=js&"
export * from "./RefreshApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports